import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { ReCaptchaV3Service } from "ng-recaptcha";
import { Observable, from, switchMap, firstValueFrom } from "rxjs";

@Injectable()
export class RecaptchaInterceptor implements HttpInterceptor {
  private recaptchaV3Service = inject(ReCaptchaV3Service);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Si no es una llamada a API o es a assets, no necesitamos un token
    if (req.url.includes("/assets/") || !req.url.includes("api")) {
      return next.handle(req);
    }

    // Para cada petición HTTP, genera un nuevo token de reCAPTCHA
    return from(this.getNewToken()).pipe(
      switchMap(token => {
        // Clona la solicitud y añade el header con el nuevo token
        const modifiedReq = req.clone({
          headers: req.headers.set('x-recaptcha-onb', token)
        });
        // Continúa con la solicitud modificada
        return next.handle(modifiedReq);
      })
    );
  }

  private async getNewToken(): Promise<string> {
    try {
      // Generamos un action único basado en la URL y timestamp
      const action = `api_call_${Date.now()}`;
      const token = await firstValueFrom(this.recaptchaV3Service.execute(action));
      return token;
    } catch (error) {
      console.error('Error al generar token de reCAPTCHA:', error);
      return '';
    }
  }
} 